if (!customElements.get('animava-order-timer')) {
  customElements.define('animava-order-timer', class extends HTMLElement {
    connectedCallback() { this.update(); this.clock = setInterval(() => this.update(), 1000); }
    disconnectedCallback() { clearInterval(this.clock); }
    update() {
      const now = new Date();
      const wall = d => {
        const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB',{timeZone:'Europe/Amsterdam',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'}).formatToParts(d).map(v=>[v.type,v.value]));
        return Date.UTC(+p.year,+p.month-1,+p.day,+p.hour,+p.minute,+p.second);
      };
      const local = new Date(wall(now));
      const cutoff = new Date(local); cutoff.setUTCHours(Number(this.dataset.cutoff)||15,0,0,0);
      const holidays = (this.dataset.holidays||'').split(',').map(v=>v.trim());
      const closed = d => [0,6].includes(d.getUTCDay()) || holidays.includes(d.toISOString().slice(0,10));
      if (local >= cutoff) cutoff.setUTCDate(cutoff.getUTCDate()+1);
      while(closed(cutoff)) cutoff.setUTCDate(cutoff.getUTCDate()+1);
      let epoch = cutoff.getTime();
      for(let i=0;i<3;i++) epoch += cutoff.getTime()-wall(new Date(epoch));
      const seconds = Math.max(0,Math.ceil((epoch-now.getTime())/1000));
      const time = `${Math.floor(seconds/3600)}u ${Math.floor(seconds%3600/60)}m ${seconds%60}s`;
      const arrival = new Date(cutoff); arrival.setUTCDate(arrival.getUTCDate()+1);
      while(arrival.getUTCDay()===0 || holidays.includes(arrival.toISOString().slice(0,10))) arrival.setUTCDate(arrival.getUTCDate()+1);
      const tomorrow = new Date(local);tomorrow.setUTCDate(tomorrow.getUTCDate()+1);
      const date = new Intl.DateTimeFormat('nl-NL',{day:'numeric',month:'long',timeZone:'UTC'}).format(arrival);
      const day = arrival.toISOString().slice(0,10)===tomorrow.toISOString().slice(0,10)?'morgen ':new Intl.DateTimeFormat('nl-NL',{weekday:'long',timeZone:'UTC'}).format(arrival)+' ';
      const target = this.querySelector('[data-timer-copy]'); if(!target)return;
      target.replaceChildren(document.createTextNode('Bestel binnen '),Object.assign(document.createElement('strong'),{textContent:time}),document.createTextNode(' voor verwachte levering '),Object.assign(document.createElement('strong'),{textContent:day+date}));
    }
  });
}
